module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAQAAABHeoekAAAAAXNSR0IArs4c6QAAAThJREFUGBkFwStrFWAcB+CnePkCGxYNhoE3NkwGZRgMJ1pmENMGplWTJgeDgQgDbwNNG7YTZpAhfgNFECzn/3vPLO5iUNGNgYbX5wG1nB85bAdZA2q5HeQwP/MctEfptZBBBu0S0KYyyKDupNc60tttgPF0zdcVgFxPR47G14Cspud3em0AdT7fkV5zUBvp7Srj6fS8h5pNR9ZGM5Cb2ycBag5GZ+spIPfrTe62J22rbbWtelkLGWYFALmXj+l5nWGGGdar9LQ8BACktyngy/F0ANRyXYA8yK/ROdqZfMsq5HSWkJ5bQHp69tLTgZpNR47GNxhP50/eZbHms5i37SAXqcvZR/po5sOx9HoMQFbS60Qm05EX2ct+vmZy+xRQEzWRnexk1DZBredv+5TdPAOylN18zr+2yX9bedRYy8U6zAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smFace.png
// module id = fQzT
// module chunks = 1